/**
 * Channel SKUs are whatever the marketplace happens to store -- real examples
 * from this account include "SNHP000084 /G2", "Blue Tang *XL*" and
 * "Mark 9V Alkaline Batteries, 20 pk", none of which are valid Ninjamo SKUs
 * (uppercase letters, digits, dot, dash and underscore only). Rather than
 * reject those rows, normalize them into a valid SKU and keep the channel's
 * raw string on the channel_listings row, where `channelSku` already exists
 * for exactly that purpose.
 *
 * Kept in its own file (no drizzle/schema imports) so both the server and the
 * client can sanitize a suggested SKU the same way -- same reasoning as
 * `shared/identity.ts` and `shared/gac.ts` being pure logic, not mixed in
 * with the heavier schema files.
 */
export function sanitizeSku(raw: string): string {
  const cleaned = raw
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9._-]+/g, "-")
    .replace(/-{2,}/g, "-")
    .replace(/^[^A-Z0-9]+/, "")
    .replace(/[^A-Z0-9._-]+$/, "")
    .slice(0, 64);
  return cleaned;
}
